
// Short-handing the dom so I don't have to type querySelector/getElementById for the billionth time
export const dom = document;

/** Shorthand for document.getElementById() */
export const elById = (selector, context = dom) => context.getElementById(selector);
/** Shorthand for document.querySelector() */
export const qs = (selector, context = dom) => context.querySelector(selector);
/** Shorthand for document.querySelectorAll() */
export const qsAll = (selector, context = dom) => Array.from(context.querySelectorAll(selector));